var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":_vm.left,"right":_vm.right,"top":_vm.top,"bottom":_vm.bottom,"color":_vm.color},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"tooltip-content"},'div',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},[_vm._t("label",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }